import { render, staticRenderFns } from "./proportionBar.vue?vue&type=template&id=653c7beb"
import script from "./proportionBar.vue?vue&type=script&lang=js"
export * from "./proportionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653c7beb')) {
      api.createRecord('653c7beb', component.options)
    } else {
      api.reload('653c7beb', component.options)
    }
    module.hot.accept("./proportionBar.vue?vue&type=template&id=653c7beb", function () {
      api.rerender('653c7beb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/bar/components/proportionBar.vue"
export default component.exports